import { InfoCircleOutlined } from "@ant-design/icons";
import { useTranslation } from "@impero-com/common/utils/i18n";
import { Alert, Button, useLocalStorage } from "@impero-com/ui";

import * as theme from "./PendingTestsMovedAlert.css";

const DISMISSED_KEY = "pendingTestsMovedAlertDismissed";

interface PendingTestsMovedAlertProps {
    onShowOnlyTests: () => void;
}

export function PendingTestsMovedAlert({
    onShowOnlyTests,
}: PendingTestsMovedAlertProps) {
    const { t } = useTranslation();
    const [dismissed, setDismissed] = useLocalStorage(DISMISSED_KEY, false);

    if (dismissed) {
        return null;
    }

    return (
        <div className={theme.frame}>
            <Alert
                type="info"
                icon={<InfoCircleOutlined />}
                message={t("Dashboard_PendingActions_TestsMovedAlert_Title")}
                description={t(
                    "Dashboard_PendingActions_TestsMovedAlert_Description"
                )}
                action={
                    <Button onClick={onShowOnlyTests}>
                        {t(
                            "Dashboard_PendingActions_TestsMovedAlert_ShowOnlyTests"
                        )}
                    </Button>
                }
                closable
                onClose={() => setDismissed(true)}
            />
        </div>
    );
}
